/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";

import MomSysShipActionButton from "../input/MomSysShipActionButton";
import getSchema from "../../lib/api/getSchema";
import MomSysAllShipButton from "../input/MomSysAllShipButton ";

function MomSysShipDetail(props) {

  const { onUpdateMaster,  onSelectMst, onSuccess, onApiFailure, isEmpty, shipState} = props;

  const [refresh, setRefresh] = useState();
  const [shipSchema, setShipSchema] = useState();

  const { t } = useTranslation();


  useEffect(() => {

    let mounted = true;

    ( async () => {

        let schema = await getSchema("MomSysLogShip");

        if ( mounted ) {

            setShipSchema(schema);

        }

    } ) ();

    return ( () => {

        mounted = false;

    } );

  },[])

  useEffect(()=>{

    if( refresh ) {
      
      refresh.refresh();

    }

  },[onSelectMst?.shipId])

  const onApiInitialized = ( api ) => {

    setRefresh ( api );

  }

  return (

    <BasicCrudScreenType
      id= "MomSysVwShipDetail"
      view= "MomSysVwShipDetail"
      headerTitle={t("term.shipDetail")}
      onApiInitialized = {onApiInitialized}
      onModifyViewUrl = {(url) => `${url}/detail/${onSelectMst.shipId}`}
      noExcel
      onInitialized = {(grid) => grid.selectionMode = "None"}
      onAppendButtonInFrontOfSearch = {
        () => (
          <>
          <BasicCrudScreenActionItemLayout>
              <MomSysAllShipButton
                  id = "MomSysShip"
                  refresh = {refresh}
                  onShipSelectMst = {onSelectMst}
                  onSuccess = {onSuccess}
                  onUpdateMaster = {onUpdateMaster}
                  disabled = {shipState === 2 || isEmpty}
                  onApiFailure = {onApiFailure}
              />
          </BasicCrudScreenActionItemLayout>
          <BasicCrudScreenActionItemLayout>
              <MomSysShipActionButton
                  id = "MomSysShip"
                  schema = {shipSchema}
                  refresh = {refresh}
                  onShipSelectMst = {onSelectMst}
                  onSuccess = {onSuccess}
                  onUpdateMaster = {onUpdateMaster}
                  disabled = {shipState === 2 || isEmpty}
              />
          </BasicCrudScreenActionItemLayout>
          </>
      )}
    />
  );
}

export default MomSysShipDetail;
